//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TopEntityComponentDistance",
  components: {
    Icon24FillDistance: () => import('@/assets/icons/Icon24FillDistance.svg?inline')
  },
  props: {
    distance: {
      type: Number,
      default: () => 0
    }
  }
}
